import React from "react";
import toniImage from "../../assets/images/pre/toni-bao.jpg";

interface TeamMember {
  id: string;
  name: string;
  role: string;
  description?: string;
  image?: string;
  category: "Founder & CEO" | "Senior Management" | "Team Leads" | "Our Genius";
}

const TEAM_MEMBERS: TeamMember[] = [
  {
    id: "1",
    name: "Toni Ebong Bao Ewoh Ebong",
    role: "Founder & CEO",
    category: "Founder & CEO",
    image: toniImage,
    description:
      "Toni is the Founder and CEO of Bao Technologies, bringing over a decade of experience from the UK technology sector across banking, insurance, energy, wealth management and media. With a professional background in software quality assurance and technology delivery, he founded Bao Technologies to explore and develop practical digital solutions designed around real challenges faced by businesses and communities, particularly across African markets. Drawing on his experience between the United Kingdom and Cameroon, Toni’s focus is on building technology that is practical, locally relevant and capable of creating meaningful economic and social value.",
  },
  {
    id: "2",
    name: "Jr Bao",
    role: "Product Owner",
    category: "Senior Management",
  },
  {
    id: "3",
    name: "Fritzel Masango",
    role: "COO",
    category: "Senior Management",
  },
  {
    id: "4",
    name: "Arrey Johnson",
    role: "Company Director",
    category: "Senior Management",
  },
  {
    id: "5",
    name: "Romanric Akam",
    role: "Developer Lead",
    category: "Team Leads",
  },
  {
    id: "6",
    name: "Lionel Ngansop",
    role: "Design Lead",
    category: "Team Leads",
  },
  {
    id: "7",
    name: "Lukong Velma",
    role: "Administrative Assistant",
    category: "Our Genius",
  },
  {
    id: "8",
    name: "Eyere Obin",
    role: "Frontend Developer/ Software Engineer",
    category: "Our Genius",
  },
  {
    id: "9",
    name: "Fonsah Pageo",
    role: "Backend Developer/ Software Engineer",
    category: "Our Genius",
  },
  {
    id: "10",
    name: "Tembong Wendy",
    role: "Associate Designer",
    category: "Our Genius",
  },
];

const TeamMemberCard: React.FC<{ member: TeamMember }> = ({ member }) => (
  <div className="relative group w-full md:w-[244px] h-[300px] rounded-[16px] overflow-hidden flex-shrink-0 bg-[#E4E4E4]">
    {member.image ? (
      <img
        src={member.image}
        alt={member.name}
        className="absolute inset-0 h-full w-full object-cover"
      />
    ) : null}

    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
    <div className="absolute bottom-[-12px] left-[-12px] w-[268px] h-[114px] bg-gradient-to-t from-black/40 to-transparent blur-[7px] pointer-events-none" />

    <div className="absolute left-5 bottom-5 flex flex-col items-start gap-[1px] z-10 w-[170px]">
      <h4 className="text-white text-[18px] font-medium font-title leading-tight">
        {member.name}
      </h4>
      <p className="text-[#DDDDDD] text-[12px] font-description font-normal leading-tight">
        {member.role}
      </p>
    </div>
  </div>
);

interface TeamSectionProps {
  categories?: TeamMember["category"][];
}

const TeamSection: React.FC<TeamSectionProps> = ({
  categories = ["Senior Management", "Team Leads", "Our Genius"],
}) => {
  return (
    <section className="bg-[#F8FAFE] py-20">
      <div className="layout-container max-w-[1360px] mx-auto px-5 flex flex-col items-center">
        <div className="flex flex-col items-center gap-5 w-full max-w-[820px] mb-14">
          <div className="px-3 py-1 rounded-full border border-[#B8B8B8] flex items-center justify-center gap-2">
            <span className="text-[#919191] text-[10px] font-description font-normal">
              Our Team
            </span>
          </div>

          <div className="flex flex-col items-center gap-3 w-full text-center">
            <h2 className="w-full text-center max-w-[640px] leading-[1.1]">
              <span className="text-[#919191] text-[32px] md:text-[40px] font-title font-medium">
                Meet the{" "}
              </span>
              <span className="text-[#212121] text-[32px] md:text-[40px] font-title font-medium">
                team behind{" "}
              </span>
              <span className="text-[#919191] text-[32px] md:text-[40px] font-title font-medium">
                Bao Technologies
              </span>
            </h2>
            <p className="w-full text-center text-[#919191] text-[13px] md:text-[14px] font-description font-light max-w-[640px] leading-[1.55]">
              Our team is made up of talented individuals who are passionate
              about technology and innovation. We work together to create
              solutions that make a difference in the world.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-10 w-full">
          {categories.map((category) => (
            <div
              key={category}
              className="flex flex-col gap-6 w-full items-center"
            >
              {/* <h3 className="text-[#919191] text-[16px] font-title font-medium leading-[1.2] text-center">
                — {category}
              </h3> */}

              <div className="flex flex-nowrap overflow-x-auto pb-6 -mx-4 px-4 md:mx-0 md:px-0 gap-4 scrollbar-hide justify-center">
                {TEAM_MEMBERS.filter((m) => m.category === category).map(
                  (member) => (
                    <div
                      key={member.id}
                      className="flex flex-col md:flex-row items-center gap-4 min-w-[244px] md:min-w-[560px] mx-auto"
                    >
                      <TeamMemberCard member={member} />

                      {member.description && (
                        <p className="text-[#919191] text-[13px] md:text-[14px] font-description font-light leading-[1.55] max-w-[360px]">
                          {member.description}
                        </p>
                      )}
                    </div>
                  ),
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
